import axios from 'axios';

const config = {
  baseURL: process.env.REACT_APP_API_URL,
};
let api = axios.create(config);

api.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

export default api;
